(() =>  {
  'use strict';

  let maxSelections = 2;
  let confirmLabel   = '';
  let selected = new Set(); // stores variant id strings
  let isAddingToCart = false;
  let activeTriggerBtn = null;
	let activeTriggerSwatches = null;

  let overlay, modal, closeBtn, itemsContainer, confirmBtn;
  let titleEl, musterTextEl, maxSpanEl, countSpanEl, confirmLabelEl;

  // -- Cache for fetched products (handle → variants[]) --
  const productCache = {};

  document.addEventListener('DOMContentLoaded', () => {
    overlay        = document.getElementById('variant-popup-overlay');
    if (!overlay) return; // snippet not included

    modal          = overlay.querySelector('.vp-modal');
    closeBtn       = overlay.querySelector('.vp-close');
    itemsContainer = overlay.querySelector('.vp-items');
    confirmBtn     = overlay.querySelector('.vp-confirm');
    titleEl        = overlay.querySelector('.vp-title');
    musterTextEl   = overlay.querySelector('.vp-muster-text');
    maxSpanEl      = overlay.querySelector('.vp-max');
    countSpanEl    = overlay.querySelector('.vp-count');

    // Wrap confirm button inner content so we can swap text safely
    confirmBtn.innerHTML = `<span class="vp-confirm-inner">${confirmBtn.innerHTML}</span>`;
    confirmLabelEl = confirmBtn.querySelector('.vp-confirm-inner');
    
    // Close events
    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) closePopup(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePopup(); });

    // Trigger buttons (delegated — works for dynamically added buttons too)
    document.addEventListener('click', (e) => {
    //   const btn = e.target.closest('.vp-trigger-btn');
      const btn = e.target.closest('.pso-card-button');
      const productCard = e.target.closest('.pso-card');
      if (!btn || !productCard) return;

      const cardSwatchesEle = productCard.querySelector('.pso-card-swatches');
      if (cardSwatchesEle) activeTriggerSwatches = cardSwatchesEle;

      activeTriggerBtn = btn; // store reference
      const handle = btn.dataset.productHandle;
      const max    = parseInt(btn.dataset.maxSelections, 10) || 2;
      const title  = btn.dataset.title || 'Farben auswählen';
      const label  = btn.dataset.confirmLabel || '';
      openPopup(handle, max, title, label);
    });

    // Confirm / Add to cart
    confirmBtn.addEventListener('click', (e) => {
			e.preventDefault();

      const cartIcon = document.querySelector('.xo-menu-hamburger__action-cart');
      if (cartIcon) cartIcon.click();
			handleConfirm();
			closePopup();
		});
  });

  function openPopup(productHandle, max, title, label) {
    maxSelections = max;
    confirmLabel  = label;
    selected.clear();

    // Set header/title
    titleEl.textContent        = title;
    musterTextEl.textContent   = max + ' Muster';
    maxSpanEl.textContent      = max;
    updateFooter();

    // Show overlay
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Load variants
    loadVariants(productHandle);
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* --------------------------------------------------------
     Fetch product variants
  -------------------------------------------------------- */
  function loadVariants(handle) {
    itemsContainer.innerHTML = '<p class="vp-loading">Lädt Varianten…</p>';

    if (productCache[handle]) {
      renderVariants(productCache[handle]);
      return;
    }

    fetch('/products/' + handle + '.js')
      .then((r) => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then((product) => {
        productCache[handle] = product.variants;
        renderVariants(product.variants);
      })
      .catch(() => {
        itemsContainer.innerHTML =
          '<p class="vp-error">Fehler beim Laden der Varianten. Bitte versuche es erneut.</p>';
      });
  }

  /* --------------------------------------------------------
     Render variant items
  -------------------------------------------------------- */
  function renderVariants(variants) {
    itemsContainer.innerHTML = '';

    if (!variants || variants.length === 0) {
      itemsContainer.innerHTML = '<p class="vp-error">Keine Varianten gefunden.</p>';
      return;
    }

    if (variants.every((v) => !v.available)) {
      itemsContainer.innerHTML = '<p class="vp-error">Alle Varianten sind ausverkauft.</p>';
      return;
    }

    variants.forEach((variant) => {
      const btn = document.createElement('div');
      btn.className            = 'vp-item';
      btn.type                 = 'div';
      btn.dataset.variantId    = variant.id;
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', 'false');

      // Swatch image or placeholder
      const media = variant.featured_image
        ? `<img src="${variant.featured_image.src}" alt="${escapeHtml(variant.title)}" loading="lazy">`
        : `<span class="vp-item-placeholder" aria-hidden="true"></span>`;

      if (!variant.available) {
        // Sold out — render but block interaction
        btn.classList.add('is-sold-out');
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.innerHTML = `
          <span class="vp-sold-out-badge">Ausverkauft</span>
          <div class="vp-item-container">
            <div class="vp-item-img">${media}</div>
            <span class="vp-item-label">
              ${escapeHtml(variant.title)}
            </span>
          </div>
        `;
      } else {
        btn.innerHTML = `
          <div class="vp-item-container">
            <div class="vp-item-img">${media}</div>
            <span class="vp-item-label">${escapeHtml(variant.title)}</span>
          </div>
        `;
        btn.addEventListener('click', () => toggleItem(btn, String(variant.id)));
      }

      itemsContainer.appendChild(btn);
    });
  }

  /* --------------------------------------------------------
     Toggle selection
  -------------------------------------------------------- */
  function toggleItem(el, variantId) {
    if (selected.has(variantId)) {
      // Deselect
      selected.delete(variantId);
      el.classList.remove('is-selected');
      el.setAttribute('aria-selected', 'false');
    } else {
      // Select — only if under max
      if (selected.size >= maxSelections) return;
      selected.add(variantId);
      el.classList.add('is-selected');
      el.setAttribute('aria-selected', 'true');
    }

    updateFooter();
    updateMaxedState();
  }

  /* --------------------------------------------------------
     Update footer counter
  -------------------------------------------------------- */
  function updateFooter() {
    const count         = selected.size;
    const isMax = (count >= maxSelections);

    // countSpanEl.textContent = count;
    confirmBtn.disabled = count === 0;

    if (isMax && confirmLabel) {
      // confirmLabel = String(confirmLabel).replace(".", ",");
      confirmLabelEl.textContent = `Für ${confirmLabel} in deinen Warenkorb`;
    } else {
        confirmLabelEl.innerHTML = `
          <span class="vp-count">${count}</span>&nbsp;von&nbsp;<span class="vp-max">${maxSelections}</span>&nbsp;gewählt
        `;
    }
  }

  /* --------------------------------------------------------
     Grey out unselectable items when at max
  -------------------------------------------------------- */
  function updateMaxedState() {
    const isMax = selected.size >= maxSelections;
    itemsContainer.querySelectorAll('.vp-item').forEach((el) => {
      const isSelected = el.classList.contains('is-selected');
      el.classList.toggle('is-maxed', isMax && !isSelected);
    });
  }

  /* --------------------------------------------------------
     Helpers
  -------------------------------------------------------- */
  function escapeHtml(str) {
    const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
    return String(str).replace(/[&<>"']/g, (m) => map[m]);
  }

/* --------------------------------------------------------
   Add to cart
-------------------------------------------------------- */
  function getSectionIds() {
    const cartMini = document.querySelector('xo-cart-mini');
    const cartMiniId = cartMini ? cartMini.id : null;
    if (cartMiniId) return [cartMiniId, 'cart-icon-bubble'];
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  // Update theme cart store so mini-cart and header icon refresh (same as adding a normal product)
  function pushCartSections(sections, itemCount) {
    if (typeof window.xoStore !== 'undefined' && sections && Object.keys(sections).length) {
      window.xoStore.set('xo-cart', function(prev) {
        return Object.assign({}, prev, { sections: sections, size: itemCount != null ? (prev.size || 0) + itemCount : (prev.size || 0) + 1 });
      })('xo-cart/updateCartSections');
    }
  }

  async function handleConfirm() {
    const sectionIds = getSectionIds();
    if (isAddingToCart || selected.size === 0) return;

    isAddingToCart = true;
    confirmBtn.disabled = true;
    confirmLabelEl.textContent = 'Wird hinzugefügt…';

    const items = Array.from(selected).map((id) => ({
      id:       Number(id),
      quantity: 1
    }));
    // console.log("This is the length of the items", items, items.length);

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const r = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: sectionIds,
          section_url: window.location.pathname
        })
      });

      if (!r.ok) throw new Error('HTTP ' + r.status);

      const cartData = await r.json();

      document.dispatchEvent(new CustomEvent('variantPopup:added', {
        bubbles: true,
        detail: { selectedIds: Array.from(selected) }
      }));

      if (cartData.sections) pushCartSections(cartData.sections, items.length);
      setTriggerSuccess();
      closePopup();

    } catch {
      confirmLabelEl.textContent = 'Fehler. Bitte erneut versuchen.';
      confirmBtn.disabled = false;

    } finally {
      isAddingToCart = false;
    }
  }

  /* --------------------------------------------------------
    Refresh cart UI — handles xo- theme component system
  -------------------------------------------------------- */
  
  function setTriggerSuccess() {
    if (!activeTriggerBtn || !activeTriggerSwatches ) return;

    activeTriggerSwatches.innerHTML = '';
    let selectedVariants = itemsContainer.querySelectorAll('.vp-items .vp-item.is-selected');
    selectedVariants.forEach((ele) => {
      let itemImage = ele.querySelector('.vp-item-img');
      let swatchHTML = `
        <div class="pso-card-swatch">
          ${itemImage.innerHTML}
        </div>
      `;
      activeTriggerSwatches.innerHTML = activeTriggerSwatches.innerHTML + swatchHTML
    })

    const btn          = activeTriggerBtn;
    const originalText = btn.textContent.trim();

    btn.textContent = 'Hinzugefügt';
    btn.classList.add('vp-trigger-btn--success');
    btn.disabled = true;

    setTimeout(() => {
      btn.textContent = originalText;
      btn.classList.remove('vp-trigger-btn--success');
      btn.disabled = false;
      activeTriggerBtn = null;
    }, 3000);
  }
})();